(() => {
  const onReady = (callback) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
    else callback();
  };

  onReady(() => {
    document.querySelectorAll('[data-product-section]').forEach((section) => {
      const select = section.querySelector('[data-variant-select]');
      if (!select) return;
      const button = section.querySelector('[data-add-to-cart]');
      const buttonText = section.querySelector('[data-add-to-cart-text]');
      const price = section.querySelector('[data-price]');
      const compare = section.querySelector('[data-compare-price]');

      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        const available = option.dataset.available === 'true';
        if (price) price.textContent = option.dataset.price;
        if (compare) {
          compare.textContent = option.dataset.comparePrice || '';
          compare.hidden = !option.dataset.comparePrice || option.dataset.comparePrice === option.dataset.price;
        }
        if (button) button.disabled = !available;
        if (buttonText) buttonText.textContent = available ? 'Add to cart' : 'Sold out';
        if (history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          history.replaceState({}, '', url.toString());
        }
      });
    });

    document.querySelectorAll('.faq-item').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        const list = item.closest('.faq-list');
        if (!list) return;
        list.querySelectorAll('.faq-item[open]').forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  });
})();
